import { Route } from '@angular/router';
import { InShellNotFoundComponent } from 'app/features/error/in-shell-not-found/in-shell-not-found.component';
import { adminFeatureCoreRoutes } from './admin-feature-core.routes';
import { adminFeatureMoreRoutes } from './admin-feature-more.routes';

export const adminFeatureRoutes: Route[] = [
    ...adminFeatureCoreRoutes,
    ...adminFeatureMoreRoutes,
    // #1349: catches any path under the authenticated shell that no feature
    // route matched, so it renders in-shell instead of falling through to
    // app.routes.ts's bare top-level 404. Must stay last.
    { path: '**', component: InShellNotFoundComponent },
];
